// extracted by mini-css-extract-plugin
export default {"category":"Brands_category__4NhbC","header":"Brands_header__DMT1Q","title":"Brands_title__-w5gR"};